import { ScaleLinear } from 'd3-scale';

import { LinePath } from '@visx/shape';
import { curveMonotoneX } from '@visx/curve';
import { Group } from '@visx/group';

import { hasNoNeighbors } from '../timeseries-chart/utils';

import { CategoryScale, CategoryValue } from './types';

type LineSeriesProps = {
  data: { categoryValue: CategoryValue; value: number | null }[];
  strokeColor: string;
  opacity?: number;
  valueScale: ScaleLinear<number, number>;
  categoryScale: CategoryScale;
};

export const LineSeries = (props: LineSeriesProps) => {
  const { data, strokeColor, opacity = 1, valueScale, categoryScale } = props;

  return (
    <Group>
      <LinePath
        data={data}
        x={({ categoryValue }) =>
          (categoryScale(categoryValue.formatted) ?? 0) + categoryScale.bandwidth() / 2
        }
        y={({ value }) => valueScale(value ?? 0)}
        defined={({ value }) => value !== null}
        stroke={strokeColor}
        strokeOpacity={opacity}
        curve={curveMonotoneX}
      />
      {data
        .filter((_, i) => hasNoNeighbors(data, i))
        .map(({ categoryValue, value }) => {
          if (value === null) {
            return null;
          }
          return (
            <circle
              key={`dot-${categoryValue.formatted}`}
              cx={(categoryScale(categoryValue.formatted) ?? 0) + categoryScale.bandwidth() / 2}
              cy={valueScale(value)}
              r={1.5}
              fill={strokeColor}
              opacity={opacity}
            />
          );
        })}
    </Group>
  );
};
